<template>
    <div class="electricity">
        <Title firstName="用电统计" lastName="ELECTRICITY STATISTICS" />
        <div class="echarts">
            <div class="edata">
                <div class="edataCon">
                    <p>本月总电量</p>
                    <p>{{sum || 21700}}<span> kWh</span></p>
                </div>
                <!-- <div class="sevenDay">近七日用电</div> -->
            </div>
            <div class="eview">
                <Bar :chartId="chartId" :seriesData="seriesData" :xData="xData" unit="kWh" v-if="seriesData.length > 0 && xData.length>0"/>
                <div class="noneData" v-else>
                    暂无数据
                </div>
            </div>
            <div class="bottom"></div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
const Title = () => import('../../components/title/Title')
const SelectList = () => import('../../components/title/selectList.vue')
const Bar = () => import('../../components/echarts/bar.vue')

import { getSevenDays, getMonthTime } from '../../utils/common'
export default {
    data(){
        return {
            chartId:'electricity',
            xData:[],
            seriesData:[],
            total:''
        }
    },
    components:{
        Title,
        SelectList,
        Bar
    },
    computed:{
        sum(){
            let sum = 0
            this.seriesData.forEach(item =>{
                sum += item 
            })
            return sum.toFixed(2)
        }
    },
    created(){
        
        if(this.$store.state.siteId == 26){
            
            this.getsiteElectricity()
            this.getWeekElectricity()
        }else{
            let time = getSevenDays()
            let timeArr = Object.values(time)

            let weekTime = []
            for(let i = 0;i <timeArr.length;i++){
                weekTime.unshift(timeArr[i].substr(5))
            }
            this.xData = weekTime
            this.seriesData = [2592, 1604, 3206, 3519, 3515, 3058, 1410]
        }
    },
    methods:{
        // 获取本月该区域的用电统计 
        async getsiteElectricity(){
            let time = getMonthTime()
            // console.log(time);
            let data ={
                areaId:this.$store.state.siteId,
                start:`${time.start}T00:00:00Z`,
                end : `${time.end}T24:00:00Z`,
            }
            let res = await this.$http.PowerAnalysisArea(data)
            console.log(res);
            this.total =res.data.data.result.total? (res.data.data.result.total ).toFixed(2):0


            
            // let time1 = getSevenDays()
            // let timeArr = Object.values(time1)

            // let weekTime = []
            // for(let i = 0;i <timeArr.length;i++){
            //     weekTime.unshift(timeArr[i].substr(5))
            // }
            // this.xData = weekTime
            // let obj = res.data.data.result[`year_${time.start.substr(0,4)}`][`month_${time.start.substr(6,1)}`]

            // let arr = []
            // weekTime.forEach(item =>{
            //     let day = item.substr(item.length - 2, 1) == '0' ? item.substr(item.length - 1, 1) :item.substr(item.length - 2, 2) 
            //     console.log(day);
            //     arr.push(obj[`day_${day}`]?obj[`day_${day}`].daySum / 1000 :0)
            // })
            // console.log(arr);
            // this.seriesData = arr

        },
        // 获取近7日用电
        async getWeekElectricity(){
            let time = getSevenDays()
            let timeArr = Object.values(time)

            let weekTime = []
            for(let i = 0;i <timeArr.length;i++){
                weekTime.unshift(timeArr[i].substr(5))
            }
            this.xData = weekTime

            let arr = []
            for(let i = 0;i<timeArr.length;i++){
                let data = {
                    areaId:this.$store.state.siteId,
                    start:`${timeArr[i]}T00:00:00Z`,
                    end:`${timeArr[i]}T24:00:00Z`,
                }
                let res = await this.$http.diagramAreaDay(data)
                arr.unshift(res.data.data.data[0]?res.data.data.data[0] :0)
            }

            this.seriesData = arr

        },
    }
}
</script>

<style lang="less" scoped>
    
    .electricity{
        height: 33.3vh;
        width: 20vw;
        position: fixed;
        top: 7.4vh;
        right: 1vw;

        .echarts{
            position: relative;
            height: 25vh;
            padding-bottom: 1vh;
            background:  linear-gradient(0deg, rgba(0, 33, 59, 0.6) 0%, rgba(3, 13, 24, 0.7) 100%);

            .edata{
                display: flex;
                justify-content: space-around;
                padding: 2.5vh 0 1vh 0;
                position: relative;
                .edataCon{
                    text-align: center;
                    p:nth-child(1){
                        font-size: 14rem;
                        font-family: Source Han Sans CN;
                        font-weight: 400;
                        color: rgba(230,243,253, 0.7);
                    }
                    p:nth-child(2){
                        padding-top: 3rem;
                        font-size: 20rem;
                        font-family: zcoolqingkehuangyouti;
                        font-weight: 400;
                        color: #00DEFF;
                        span{
                            font-size: 14rem;
                        }
                    }
                }
                .fenbu{
                    position: absolute;
                    right: 1vw;
                    top: 1vh;
                    width: 88rem;
                    height: 30rem;
                    line-height: 30rem;
                    text-align: center;
                    border-radius: 2rem;
                    color: rgba(230,243,253, 0.7);
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    background: url('../../assets/img/dwbgw.png');
                    background-size: 100% 100%;
                    cursor: pointer;
                    img{
                        width: 18rem;
                        height: 14rem;
                        vertical-align: -2rem;
                    }
                }
                .col{
                    color: #0d94ff;
                    background: url('../../assets/img/dwbj.png');
                    background-size: 100% 100%;

                }
                
                .sevenDay{
                    font-size: 12rem;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: rgba(230,243,253, 0.7);
                    position: absolute;
                    right: 1vw;
                    top: 6.5vh;
                }
            }

            .eview{
                width: 100%;
                padding: 0 0.5vw;
                height: 16.5vh;
                position: relative;
                #electCharts{
                    width: 100%;
                    height: 100%;
                }

                .noneData{
                    display: inline-block;
                    position: absolute;
                    top: 50%;
                    color: rgba(230,243,253, 0.7);
                    left: 50%;
                    transform: translate(-50% , -50%);
                }
            }

            .bottom{
                width: 20vw;
                height: 1vh;
                background: url(../../assets/img/板块装饰线.png) no-repeat;
                block-size: 100% 100%;
                position: absolute;
                bottom: 0;
                left: 0;
            }
        }

        
    }

</style>